// src/components/SalonManagement/ProductSection/ProductCard.tsx
import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";
import { SelectProduct } from "../../../types/salon.types";
import Image from "src/shared/Image";

interface ProductCardProps {
  product: SelectProduct;
  isSelected: boolean;
  onSelect: (product: SelectProduct) => void;
}

const ProductCard: React.FC<ProductCardProps> = ({ product, isSelected, onSelect }) => {
  return (
    <Card
      onClick={() => onSelect(product)}
      sx={{
        borderRadius: 2,
        transition: "all 0.3s ease",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        "&:hover": {
          transform: "translateY(-3px)",
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        },
        border: isSelected ? "2px solid var(--background-color)" : "1px solid #e0e0e0",
        backgroundColor: "#f2f2f2",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        cursor: "pointer",
      }}
    >
      <CardContent
        sx={{
          p: 2,
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
        }}
      >
        {/* Product Image */}
        <Box
          sx={{
            flexShrink: 0,
            mb: 2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 140,
            overflow: "hidden",
          }}
        >
          <Image imagePath={product.image_url} className='w-full h-full' />
        </Box>

        {/* Product Info */}
        <Box sx={{ flexGrow: 1 }}>
          <Typography
            variant='subtitle1'
            sx={{
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
              wordBreak: "break-word",
            }}
          >
            {product.ProductName}
          </Typography>

          {product.ArabicName && (
            <Typography
              variant='body2'
              color='text.secondary'
              sx={{
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                textOverflow: "ellipsis",
                wordBreak: "break-word",
                mt: 0.5,
              }}
            >
              {product.ArabicName}
            </Typography>
          )}
        </Box>

        {/* Price */}
        <Typography variant='subtitle2' sx={{ fontWeight: "bold", mt: 1, textAlign: "right" }}>
          {Number(product.Amount).toFixed(2)}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default ProductCard;
